import { createContext, useContext, useEffect, useState } from "react";
import io from "socket.io-client";

const SOCKET_URL = window.location.origin.includes("localhost")
    ? process.env.REACT_APP_SOCKET_HOST
    : process.env.REACT_APP_SOCKET_HOST;

const SocketContext = createContext();

const useSocketContext = () => useContext(SocketContext);

const SocketProvider = ({ children, token }) => {
    const [socket, setSocket] = useState(null);

    useEffect(() => {
        if (token) {
            const newSocket = io.connect(SOCKET_URL,  {
                transports: ['websocket'], 
                auth: { token: token } 
            });
            setSocket(newSocket);

            return () => newSocket.close();
        }
    }, [token]);

    return (
        <SocketContext.Provider value={socket}>{children}</SocketContext.Provider>
    );
};

export { useSocketContext, SocketProvider };
